// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ItIns","group":"styles_group__95jXh","groupTitle":"styles_groupTitle__tTKa3","cards":"styles_cards__DqiSH"};